import { PropsWithChildren } from "react";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

const FormSectionGrid = ({ children }: PropsWithChildren) => (
  <Grid
    container
    mt={3}
    columnSpacing={{ xs: 4, sm: 2, md: 2, lg: 4 }}
    rowGap={3}
  >
    {children}
  </Grid>
);

export default FormSectionGrid;
